// extracted by mini-css-extract-plugin
export default {"container":"RiverInterest_container__5B02d","icon":"RiverInterest_icon__gNgIM","content":"RiverInterest_content__pH8uR"};